import React, { FC } from 'react'

import { Card } from 'src/components/atoms'
import { InternalUserRole } from 'src/components/organisms'

import { InternalUserDetailEntity } from 'src/types'

type Props = {
  user: InternalUserDetailEntity
  className?: string
}

export const InternalUserRoleCard: FC<Props> = ({ user, className }) => {
  return (
    <div className={className}>
      <Card padding="--s1">
        <InternalUserRole user={user} />
      </Card>
    </div>
  )
}
